import AppConfig from "util/AppConfig";
const shouldRenderNavigationItem = (requiredFeatureFlag, requiredPermissions, isPermitted) => {
  if (requiredFeatureFlag && !AppConfig.isFeatureEnabled(requiredFeatureFlag)) {
    return false;
  }
  if (requiredPermissions && !isPermitted(requiredPermissions)) {
    return false;
  }
  return true;
};
export default shouldRenderNavigationItem;
